import { render, staticRenderFns } from "./Final.vue?vue&type=template&id=3486410d&scoped=true&"
import script from "./Final.vue?vue&type=script&lang=js&"
export * from "./Final.vue?vue&type=script&lang=js&"
import style0 from "./Final.vue?vue&type=style&index=0&id=3486410d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486410d",
  null
  
)

export default component.exports